import RequestPasswordReset from "./RequestPasswordReset.vue";
export default RequestPasswordReset;
